module.exports = __webpack_public_path__ + "static/media/wing-szn-cover.e9ec8f1b.webp";